import { useEffect, useState } from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { useModelInfo } from '../common/ModelInfoContext';

const useQueryParams = (isDefaultPostalCode, postalCode) => {
  const { transactionIdKey, lccKey } = useModelInfo();
  const location = useLocation();
  const navigate = useNavigate();
  const [newLoc, setNewLoc] = useState('');
  const [searchParams] = useSearchParams();

  const bacsSearch = searchParams.get('bacs');
  const ezCustomerSearch = searchParams.get('ez');
  const postalCodeSearch = searchParams.get('postalcode');
  const transactionId = searchParams.get(lccKey);

  useEffect(() => {
    if (bacsSearch) {
      sessionStorage.setItem('bacs', bacsSearch);
    }

    if (ezCustomerSearch) {
      sessionStorage.setItem('ez', ezCustomerSearch);
    }

    if (transactionId) {
      sessionStorage.setItem(transactionIdKey, transactionId);
    }
  }, []);

  useEffect(() => {
    if (postalCodeSearch) {
      const isStoredPostal = !isDefaultPostalCode && postalCode;
      sessionStorage.setItem(
        'postalcode',
        isStoredPostal ? postalCode : postalCodeSearch
      );
      if (isStoredPostal) {
        const params = new URLSearchParams(searchParams);
        params.set('postalcode', postalCode);
        navigate({
          pathname: location.pathname,
          search: '?' + params,
        });
      }
    }
  }, [isDefaultPostalCode, postalCode]);

  useEffect(() => {
    const params = new URLSearchParams(searchParams);
    const {
      bacs: bacParam,
      ez: custIdParam,
      postalcode: postalCodeParam,
      [transactionIdKey]: lccParam,
    } = sessionStorage;

    if (bacParam && !bacsSearch) {
      params.set('bacs', bacParam);
    }
    if (custIdParam && !ezCustomerSearch) {
      params.set('ez', custIdParam);
    }
    if (postalCodeParam && params.get('postalcode') !== postalCodeParam) {
      params.set('postalcode', postalCodeParam);
    }
    if (lccParam && !transactionId) {
      params.set(lccKey, lccParam);
    }
    if (
      location.pathname !== newLoc &&
      (bacParam || custIdParam || postalCodeParam || lccParam)
    ) {
      navigate({
        pathname: location.pathname,
        search: '?' + params,
      });
      setNewLoc(location.pathname);
    }
  }, [location?.pathname]);
};

export default useQueryParams;
